export default __webpack_public_path__ + "static/home_page_ordering-c990c11e3c471944433db4b53336c986.webm";